module.exports = __webpack_public_path__ + "img/36.e3e5af9b.png";